import SaleItem from "../../../../utilities/data/model/SaleItem";
import Sale from "../../../../utilities/data/model/Sale";

export const useApplyTradePriceToSaleItems = () => {
  const { applyTradePrice } = useApplyTradePriceAction();

  const applyTradePriceToSaleItems = async (sale: Sale): Promise<Sale> => {
    const saleItems = await sale.items.fetch();

    for (const saleItem of saleItems) {
      await applyTradePrice(saleItem);
    }

    return sale;
  };

  return {
    applyTradePriceToSaleItems,
  };
};

export const useApplyTradePriceAction = () => {
  const applyTradePrice = async (saleItem: SaleItem): Promise<SaleItem> => {
    await saleItem.applyTradePrice();
    // logic moved to SaleItem model
    return saleItem;
  };

  return {
    applyTradePrice,
  };
};
